import { LayoutHOC } from 'base/ui/layout/layout';
import { visitCustomerRoute } from './routes';
import createPageDetailRateVisitCustomer from './detailRateOfVisitCustomerSR';
import createPageGeneralRateVisitCustomer from './generalRateOfVisitCustomerSR';
import createPageRatioReviewToTotalViews from './ratioReviewToTotalViews';
import createPageAverageRatingOverTime from './averageRatingOverTime';
import { createPageRatioReviewUnsatisfied } from './ratioReviewUnsatisfied';
import createWarrantyActiveReport from './warrantyActiveReport';
import createCustomerSurveyReport from './CustomerSurveyReport';
import createWorkStatusReport from './workStatus';
import createStatisticsRevenueReport from './statisticRevenue';
import createStatisticsWarrantyReport from './statisticWarranty';
import createCustomerGeneralReport from './CustomerGeneralReport';

export const createReportVisitCustomerPage = (layoutHOC: LayoutHOC) => {
  const DetailRateVisitCustomer = createPageDetailRateVisitCustomer();
  const GeneralRateVisitCustomer = createPageGeneralRateVisitCustomer();
  const RatioReviewToTotalViews = createPageRatioReviewToTotalViews();
  const EverageRatingOverTime = createPageAverageRatingOverTime();
  const RatingUnsatisfied = createPageRatioReviewUnsatisfied();
  const WarrantyActive = createWarrantyActiveReport();
  const CustomerSurvey = createCustomerSurveyReport();

  const StatisticsRevenue = createStatisticsRevenueReport();
  const StatisticsWarranty = createStatisticsWarrantyReport();

  // Báo cáo trạng thái công việc NVKT
  const WorkStatus = createWorkStatusReport();
  // Báo cáo tổng hợp khách hàng
  const CustomerGeneralReport = createCustomerGeneralReport();

  const PageVisitCustomer = layoutHOC(visitCustomerRoute);
  return () => (
    <PageVisitCustomer
      DetailRateVisitCustomer={DetailRateVisitCustomer}
      GeneralRateVisitCustomer={GeneralRateVisitCustomer}
      RatioReviewToTotalViews={RatioReviewToTotalViews}
      EverageRatingOverTime={EverageRatingOverTime}
      RatingUnsatisfied={RatingUnsatisfied}
      WarrantyActiveReport={WarrantyActive}
      CustomerSurveyReport={CustomerSurvey}
      WorkStatusReport={WorkStatus}
      StatisticsRevenueReport={StatisticsRevenue}
      StatisticsWarranty={StatisticsWarranty}
      CustomerGeneralReport={CustomerGeneralReport}
    />
  );
};
